import api from './api';

// Jours ouvrés par territoire (Administration ▸ Jours ouvrés, super-admin).
// Ex-/budget/jours-ouvres, déplacé quand le Reporting Financier a été supprimé (2026-10-26).
const joursOuvresApi = {
  getAll: (params) => api.get('/jours-ouvres', { params }),
  getDimensions: () => api.get('/jours-ouvres/dimensions'),
  getCount: (params) => api.get('/jours-ouvres/count', { params }),
  basculer: (id, est_ouvre) => api.put(`/jours-ouvres/${id}`, { est_ouvre }),
  importer: (formData) => api.post('/jours-ouvres/import', formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
};

export default joursOuvresApi;
